// // src/config/constants.js
// export const API_BASE_URL = 'http://192.168.1.2:5265/api/';
// export const FILE_BASE_URL = 'http://192.168.1.2:5265/Files'; 
// export const APP_NAME = 'WebMinds Signage';
// export const THEME = 'light';
// export const DEFAULT_LANGUAGE = 'en';
// export const SUPPORT_EMAIL = 'support@webmindstechnologies.com';

export const API_BASE_URL = 'https://signageapi.amigotechnocrats.com/api/';
export const FILE_BASE_URL = 'https://signageapi.amigotechnocrats.com/Files'; 
export const APP_NAME = 'WebMinds Signage';
export const THEME = 'light';
export const DEFAULT_LANGUAGE = 'en';
export const SUPPORT_EMAIL = 'support@webmindstechnologies.com';


//src/config/constants.js
// export const API_BASE_URL = 'http://192.168.85.31:8080/api/';
// export const FILE_BASE_URL = 'http://192.168.85.31:8080/Files'; 
// export const APP_NAME = 'Bronx Signage';
// export const THEME = 'light';
// export const DEFAULT_LANGUAGE = 'en';
// export const SUPPORT_EMAIL = 'support@webmindstechnologies.com';